<template>
    <div class="selectedBlock">
      <h3> 
        <span class="back" @click="$emit('clear-selected-block')">Back</span> 
        Block {{block.height}}
      </h3>
      <div class="block-info">
        <div>
          <span>Hash</span> 
          <a class="hashAddress" @click="copyHash">
          {{block.id.slice(0,20)}}
          ...
          {{block.id.slice(-10)}}
          </a>
        </div>
        <div><span>Median Fee</span> <span>???</span></div>
        <div><span>Timestamp</span> <span>{{moment(block.timestamp * 1000).utc().format('YYYY-MM-DD HH:mm')}} ({{moment(block.timestamp * 1000).fromNow()}})</span></div>
        <div><span>Total fees</span> <span>???</span></div>
        <div><span>Size</span> <span>{{bytesToSize(block.size)}}</span></div>
        <div><span>Subsidy + fees</span> <span>???</span></div>
        <div><span>Weight</span> <span>{{(block.weight / 1000000).toFixed(2)}} MWU</span></div>
        <div><span>Miner</span> <span>???</span></div>
      </div>
      <div class="block-txs" v-if="blockTxs.length">
        <div class="block-txs-header">
          <h3>{{block.tx_count}} transactions</h3>
          <paginate
          v-model="blockTxsCurrentPage"
          :pageCount="Math.ceil(block.tx_count / 25)"
          prevText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.928066 3.24063L4.63608 0.0756431C4.76156 -0.0140025 4.91737 0.000932952 5.03505 0.000932952C5.50575 0.000932952 5.50366 0.437028 5.50366 0.547511V7.10658C5.50366 7.19998 5.50572 7.65319 5.03505 7.65319C4.91737 7.65319 4.76153 7.66806 4.63608 7.57844L0.928093 4.32524C0.57971 4.07649 0.639907 3.78292 0.639907 3.78292C0.639907 3.78292 0.579682 3.48935 0.928066 3.24063Z" fill="#5371B3"/></svg>'
          nextText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07193 3.24063L1.36392 0.0756431C1.23844 -0.0140025 1.08263 0.000932952 0.964953 0.000932952C0.49425 0.000932952 0.496338 0.437028 0.496338 0.547511V7.10658C0.496338 7.19998 0.494277 7.65319 0.964953 7.65319C1.08263 7.65319 1.23847 7.66806 1.36392 7.57844L5.07191 4.32524C5.42029 4.07649 5.36009 3.78292 5.36009 3.78292C5.36009 3.78292 5.42032 3.48935 5.07193 3.24063Z" fill="#5371B3"/></svg>'
          :containerClass="'pagination'">
          </paginate>
        </div>
        <div class="block-txs-list">
          <div v-for="item in blockTxs" :key="item.txid" class="tx">
            <div class="txid">{{item.txid}}</div>
            <div class="time">{{moment(item.status.block_time * 1000).utc().format('YYYY-MM-DD HH:mm')}}</div>
          </div>
        </div>
        <div class="flex">
          <paginate
          v-model="blockTxsCurrentPage"
          :pageCount="Math.ceil(block.tx_count / 25)"
          prevText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.928066 3.24063L4.63608 0.0756431C4.76156 -0.0140025 4.91737 0.000932952 5.03505 0.000932952C5.50575 0.000932952 5.50366 0.437028 5.50366 0.547511V7.10658C5.50366 7.19998 5.50572 7.65319 5.03505 7.65319C4.91737 7.65319 4.76153 7.66806 4.63608 7.57844L0.928093 4.32524C0.57971 4.07649 0.639907 3.78292 0.639907 3.78292C0.639907 3.78292 0.579682 3.48935 0.928066 3.24063Z" fill="#5371B3"/></svg>'
          nextText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07193 3.24063L1.36392 0.0756431C1.23844 -0.0140025 1.08263 0.000932952 0.964953 0.000932952C0.49425 0.000932952 0.496338 0.437028 0.496338 0.547511V7.10658C0.496338 7.19998 0.494277 7.65319 0.964953 7.65319C1.08263 7.65319 1.23847 7.66806 1.36392 7.57844L5.07191 4.32524C5.42029 4.07649 5.36009 3.78292 5.36009 3.78292C5.36009 3.78292 5.42032 3.48935 5.07193 3.24063Z" fill="#5371B3"/></svg>'
          :containerClass="'pagination'">
          </paginate>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name:'selectedBlock',
  props:['block'],
  data: () => ({
    blockTxs: [],
    blockTxsCurrentPage:1,
  }),
  watch:{
    block(){
      this.blockTxsCurrentPage = 1;
      this.blockTxs = [];
      this.getBlockTxs();
    },
    blockTxsCurrentPage(){
      this.getBlockTxs()
    },
  },
  methods:{
    getBlockTxs(){
      axios.get(`https://blockstream.info/api/block/${this.block.id}/txs/${(this.blockTxsCurrentPage - 1) * 25}`).then(response => {
        if (response.status == 200)
        this.blockTxs = response.data
      });
    },
    copyHash(){
      this.copyToClipboard(this.block.id);
      this.$notify({
        type: 'success',
        text: 'Copied'
      });
    }
  },
  mounted(){
    this.getBlockTxs();
  }
}
</script>

<style lang="scss">
  .selectedBlock{
    h3{
      display: flex;
      span{
        color: #3868F8;
        font-size: 18px;
        margin-right: 10px;
        cursor: pointer;
        &:before {
          content: " ";
          width: 16px;
          height: 9px;
          display: inline-block;
          vertical-align: middle;
          background: #3868F8;
          transform: rotate(180deg);
          margin-right: 5px;
          -webkit-mask: url('../../../assets/img/arrow.png') no-repeat;
        }
      }
    }
    .block-info{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      & > div{
        background: var(--table-th-bg);
        border-radius: 2px;
        padding: 8px 14px;
        width: calc(50% - 5px);
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        span{
          color:var(--font-color)
        }
        .hashAddress{
          cursor: pointer;
          color: #3868F8;
          transition: none;
          &:after{
            content: ' ';
            width: 16px;
            height: 16px;
            display: inline-block;
            background: #3868F8;
            -webkit-mask: url('../../../assets/img/copy_white.svg') no-repeat;
            margin-left: 10px;
            position: relative;
            top: 2px;
          }
          &:active{
            color: var(--font-color);
            &::after{
              background: var(--font-color);
            }
          }
        }
      }
    }
    .block-txs{
      .block-txs-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .block-txs-list{
        .tx{
          background: var(--table-th-bg);
          padding: 8px 14px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          .txid{
            color: #3868F8;
            cursor: pointer;
          }
          .time{
            font-weight: 600;
            color:var(--font-color);
          }
        }
      }
      .flex{
        justify-content: flex-end;
      }
    }
  }
</style>